import axios from './HTTP'

export default {
  update (idAndFields, callback, errorCallback) {
    axios
      .patch(`/api/worksites/${ idAndFields.id }.json`, idAndFields)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  create (params, callback, errorCallback) {
    axios
      .post(`/api/worksites.json`, { worksite: params })
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },
  // getEmployees (locationId, callback, errorCallback) {
  //   axios
  //     .get(`/api/worksites/${ locationId }/employees.json`)
  //     .then(response => {
  //       callback(response.data)
  //     })
  //     .catch(error => {
  //       errorCallback(error)
  //     })
  // },

}
